import {
  useReportBespoke,
  useReportContext,
  useRiskExposure,
} from "@iliotech/data-wire";
import { TimeSeriesChartItem } from "@iliotech/widgets";
import TimeSeriesLineChart from "@iliotech/widgets/src/components/TimeSeriesLineChart/TimeSeriesLineChart";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React from "react";
import { useParams } from "react-router-dom";
import { ReportWidgetProps } from "../../ReportWidgetProps";

export const DailyLeverageRatioWidget = observer(
  ({ height, width, periodContext }: ReportWidgetProps) => {
    const categoryFormatter = false
      ? (val: Date) => moment(val).format(`MMMM 'YY`)
      : (val: Date) => moment(val).format(`DD MMM 'YY`);
    const periodString = periodContext.periodString;
    const { portfolioId } = useParams<{ portfolioId: string }>();
    const store = useReportBespoke();
    const { generating } = store;
    const riskExposure = useRiskExposure({
      portfolioId: portfolioId!,
      frequency: "Daily",
      overridePeriod: periodContext.periodForRequest,
    });
    const leverageRatioData: TimeSeriesChartItem[] = React.useMemo(() => {
      const rawData = riskExposure.data?.data?.marketValueAndExposure;

      if (!rawData || !Array.isArray(rawData)) {
        return [];
      }

      return [
        {
          category: "Leverage Ratio",
          entries: rawData.map((d) => ({
            date: new Date(d.date),
            value: d.exp / d.mv,
          })),
          color: "#ea7250",
        },
      ];
    }, [riskExposure?.data]);

    return (
      <div>
        <h3 className={"element-title"}>{`Daily Leverage Ratio`}</h3>
        <p className={"period-string"}>{periodString}</p>
        <TimeSeriesLineChart
          height={height || 250}
          width={width}
          isPdf={generating}
          chartStyle={{ height: height || 250 }}
          tooltipSettings={{
            hideTotal: true,
          }}
          chartCategoryAxisItemProps={{
            labels: {
              rotation: "auto",
            },
          }}
          categoryAxisFormatter={(e: string) =>
            categoryFormatter(e as unknown as Date)
          }
          valueAxisFormatter={(s: number) => s?.toFixed(2)}
          items={leverageRatioData}
        />
      </div>
    );
  }
);
